import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import {SENTRY_DSN} from './config/env'
import App from './App'
import NotFoundPage from './components/pages/NotFoundPage'
import {parseRoute} from './utils/routeParser'
import {applyTheme} from './config/applyTheme'
import './index.css'

// Прокидываем палитру (src/config/colors.js) в CSS-переменные до первого рендера.
applyTheme();

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js').catch(() => {});
    });
}

if (import.meta.env.PROD) {
    Sentry.init({
        dsn: SENTRY_DSN,
        integrations: [
            Sentry.replayIntegration()
        ],
        replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    })
}

// Path-based routing.
function Router() {
    const path = window.location.pathname;
    const route = parseRoute(path);

    // Мои заказы (только сказки).
    if (route.type === 'orders') {
        return <App view="orders"/>;
    }

    // Открыть конкретную сказку по ссылке.
    if (route.type === 'skazkiTale') {
        return <App view="app" skazkiTaleId={route.taleId}/>;
    }
    // Создать новую сказку.
    if (route.type === 'skazkiNew') {
        return <App view="app" skazkiAction="new"/>;
    }

    // Приложение «Сказки» на «/app».
    if (route.type === 'app') {
        return <App view="app"/>;
    }

    // Главная «/» — лендинг.
    if (route.type === 'landing') {
        return <App view="landing"/>;
    }

    // 404 page
    return <NotFoundPage/>;
}

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <Sentry.ErrorBoundary fallback={
            <div style={{minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'sans-serif', padding: '20px', textAlign: 'center'}}>
                <div>
                    <p style={{fontSize: '18px', color: '#333', marginBottom: '16px'}}>Что-то пошло не так. Попробуйте обновить страницу.</p>
                    <button onClick={() => window.location.reload()} style={{padding: '12px 24px', background: 'linear-gradient(to right, #e53e3e, #ed64a6, #ed8936)', color: 'white', border: 'none', borderRadius: '12px', fontSize: '16px', cursor: 'pointer'}}>
                        Обновить
                    </button>
                </div>
            </div>
        }>
            <Router/>
        </Sentry.ErrorBoundary>
    </React.StrictMode>,
)
